import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ACCOUNT_BLOCKED_API_ERRORS, ApiError } from 'services/api.errors';
import {
  ConfirmChangingPasswordPayload,
  ConfirmChangingPasswordResponse,
} from 'services/requests';
import { useNavigate } from 'hooks/routes';
import { useRole } from 'hooks/common/useRole';
import { protectApiError } from 'utils/typeGuards';
import { MutationKeys } from 'constants/mutationKeys';
import { Messages } from 'constants/messages';
import { showInfoToast } from 'components/Toast';

export const useConfirmChangingPassword = () => {
  const mutate = async (payload: ConfirmChangingPasswordPayload) => {
    const { data } = await api.confirmChangingPassword(payload);

    return data;
  };

  const mutationKey = MutationKeys.confirmChangingPassword;
  const { isAdmin } = useRole();
  const { toEmployers, toLoginBlocked } = useNavigate();

  return useMutation<
    ConfirmChangingPasswordResponse,
    AxiosError<ApiError>,
    ConfirmChangingPasswordPayload
  >(mutationKey, mutate, {
    onSuccess: (tokenData) => {
      api.setTokens(tokenData?.accessToken, tokenData?.refreshToken);
      showInfoToast(Messages.passwordHasBeenChanged);
      if (isAdmin) {
        toEmployers();
      } else {
        // NOTE: Disabled in ETZ-2825. Need to check actuality. Related to 'Role User'
        // toBanckAccountUser();
      }
    },
    onError: (error) => {
      if (protectApiError(error) && error.response?.data.code) {
        if (ACCOUNT_BLOCKED_API_ERRORS.includes(error.response?.data.code)) {
          api.logout();
          api.logoutApp();
          toLoginBlocked(error.response?.data);
        }
      }
    },
  });
};
